<template>
  <div class="wrapper flex-row align-center full-parent">
    <img
      draggable="false"
      class="bg skeleton swiper-lazy"
      data-src="https://mm2015.mamalaile.com.cn/0e79840a00641a2ae0251d2999f49443.png"
    />
    <img
      draggable="false"
      class="mp swiper-lazy"
      src="https://mm2015.mamalaile.com.cn/35a781e454026bb31d7eec37438cbc25.png"
    />
    <div class="swiper-lazy-preloader" />
    <div class="info-text">
      <div class="title">互联网孕期工具</div>
      <div class="title">坐一个充满科技感的月子</div>
      <img
        draggable="false"
        class="dot"
        src="~@/assets/images/home_pic6_title@2x.png"
      />
      <div class="divider" />
    </div>
    <div class="info-block">
      <slideInfo
        title="小程序介绍"
        desc="妈妈来了小程序不仅是一个帮助您选月嫂的工具，还能查看月嫂/护理老师的服务状态和上报的护理事项，全方位了解自己和宝宝的健康。#同时，小程序里还提供了丰富的孕期/育儿小工具，为您在月子期间增添乐趣，快去使用看看吧！"
        buttonText="打开小程序"
      />
    </div>

    <decorate :list="decorateList" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

export default defineComponent({
  components: { slideInfo },

  data() {
    return {
      decorateList: [
        // { position: 'top-right', url: require('/src/assets/images/home_pic3_bg2.png'), width: 33 },
      ]
    };
  }
});
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;

  .info-block {
    margin-left: 19.22vw;
  }

  .bg {
    width: 50vw;
    height: 100%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .info-text {
    position: absolute;
    left: 10.47vw;
    top: 50%;
    transform: translateY(-50%);

    .title {
      font-size: 1.82vw;
      line-height: 2.5vw;
      color: white;
      font-family: @font-ab;
    }

    .dot {
      width: 0.99vw;
      height: auto;
      position: absolute;
      top: 3.66vw;
      right: 0;
      transform: translateX(calc(100% + 0.52vw));
    }

    .divider {
      width: 1.2vw;
      height: 1px;
      background-color: white;
      margin-top: 4.06vw;
    }
  }

  .mp {
    width: 22.03vw;
    height: 42.81vw;
    position: absolute;
    top: 50%;
    left: 38.96vw;
    transform: translateY(-50%);
  }
}
</style>